/* eslint-disable class-methods-use-this */
import {
	researchFour, researchOne, researchThree, researchTwo,
} from 'assets/images/research';
import { CLabModel } from '../dto/lab-model';
import { IResearchApi } from './research-api';

export class CResearchApiImpl implements IResearchApi {
	getLabs(): Promise<CLabModel[]> {
		try {
			const labs = [{
				id: 1,
				image: researchOne,
			},
			{
				id: 2,
				image: researchTwo,
			},
			{
				id: 3,
				image: researchThree,
			},
			{
				id: 4,
				image: researchFour,
			},
			];

			const labsPromise = new Promise((resolve) => {
				setTimeout(() => {
					resolve(labs);
				}, 300);
			});

			return labsPromise.then(() => labs);
		} catch (error) {
			throw new Error('An Error Occurred');
		}
	}
}
